// /*global define, console, window, HTMLImageElement, Promise*/
// (window.MyModule = function ($, Behaviors) {
//     "use strict";
//     var module = {};
//     function JonathanGreenHTML(elem) {
//         Behaviors.init(JonathanGreenHTML, this, arguments);
//         var $thisElem = this.$elem;
        

//         if ($('.external-search-active').length > 0) {
            
//             // setTimeout(function() { 
//             //     $('.external-search-active #storepoint-container').addClass( "submit-it-iframe" );
//             //     $('.external-search-active form#storepoint-search').trigger( "submit" );
//             //     $('.external-search-active form#storepoint-search #storepoint-searchbar-submit').trigger( "click" );
//             // }, 5500);
            
//         }

//     }
//     Behaviors.inherit(JonathanGreenHTML, Behaviors.Behavior);
//     JonathanGreenHTML.QUERY = "[data-JonathanGreenHTML]";
//     JonathanGreenHTML.ELEMENTS = {
//         loadMoreButton: ".AwardTabs-content_tabs_items_item_loadMore__button",
//     };
//     Behaviors.register_behavior(JonathanGreenHTML);
//     module.JonathanGreenHTML = JonathanGreenHTML;
//     return module;
// }(window.jQuery, window.Behaviors));
